// extracted by mini-css-extract-plugin
module.exports = {"input":"SearchBar_input__6VZCV","searchSection":"SearchBar_searchSection__u_p2f","errorText":"SearchBar_errorText__4SYrS","searchButton":"SearchBar_searchButton__w5AmH"};